export const vertexShader = `
uniform sampler2D u_visibility;
        uniform float u_size;
        uniform float u_time_since_click;
        uniform vec3 u_clicked;

        varying float vOpacity;

        float circle(vec2 st, float r) {
            vec2 dist = st - vec2(0.5);
            return 1.0 - smoothstep(0.99 * r, 1.01 * r, dot(dist, dist) * 4.0);
        }

        void main() {
            // mask with world map
            float visibility = 1.0 - step(0.4, texture2D(u_visibility, uv).x);
            gl_PointSize = visibility * u_size;

            // add ripple
            float time = u_time_since_click;
            float dist = length(position - u_clicked);
            float damping = pow(1.0 - sin(min(time, 1.0)), 5.0);
            float wave = (1.0 + sin(3.0 * dist + 13.0 * time));
            float delta = -0.025 * damping * wave;

            // make backside dots darker
            vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);
            vOpacity = (1.0 / length(mvPosition.xyz) - 0.7);
            vOpacity = clamp(vOpacity, 0.0, 0.5) + 0.01;

            gl_Position = projectionMatrix * modelViewMatrix * vec4(position * (1.0 + delta), visibility);
        }
`;

export const fragmentShader = `
uniform vec3 u_color_main;
        varying float vOpacity;

        void main() {
            vec3 dot_color = u_color_main; // Определенный цвет точки

            // Определение радиуса точки и радиуса свечения
            float dot_radius = 0.5; // Увеличьте радиус точки
            float glow_radius = 2.0; // Увеличьте радиус свечения

            // Вычисление расстояния от текущей координаты до центра точки
            float dot_dist = length(gl_PointCoord - 0.5);

            // Если расстояние меньше радиуса точки, то точка светится, иначе она прозрачна
            if (dot_dist < dot_radius) {
                // Уменьшите opacity, чтобы сделать точку менее прозрачной
                float opacity = 0.3 * (1.0 - dot_dist / dot_radius);

                // Если расстояние меньше радиуса свечения, то точка светится
                if (dot_dist < glow_radius) {
                    opacity = vOpacity;
                }

                // Смешивание цвета точки с цветом свечения
                vec3 final_color = mix(dot_color, vec3(.0, 0.6, 1.0), dot_dist / dot_radius);

                gl_FragColor = vec4(final_color, opacity);
            } else {
                discard; // Отбросить точки, которые находятся за пределами радиуса
            }
        }
`;
